export interface AssistantState {
  prepareDocumentAssistant: {
    isActive: boolean;
  };
  bookkeepingAssistant: {
    isActive: boolean;
  };
}

const state: AssistantState = {
  prepareDocumentAssistant: {
    isActive:
      localStorage.getItem('prepareDocumentAssistant') === 'true' ||
      localStorage.getItem('prepareDocumentAssistant') === null
  },
  bookkeepingAssistant: {
    isActive:
      localStorage.getItem('bookkeepingAssistant') === 'true' ||
      localStorage.getItem('bookkeepingAssistant') === null
  }
};

export default state;
